<template>
    <div>
        <div :class="{'is-loading is-loading-dark': isLoading}">
        </div>
        <message-component v-if="showError" :status="errorStatus" :message="errorMessage"></message-component>
        <section v-if="fixtureDays">
            <div v-for="(fixtures, key) in fixtureDays" :key="key">
                <span class="section-title section-title-sub">{{ key }}</span>
                <ul class="fixtures">
                    <fixture-component :status="fixture.status" v-for="(fixture, fixtureKey, index) in fixtures"
                        :fixture="fixture" :key="index"></fixture-component>
                </ul>
            </div>
            <ul class="ticker" v-if="Object.keys(fixtureDays).length === 0">
                <li class="pre">
                    <span class="clearfix">
                        <span class="icon"></span>
                        <span class="time"></span>
                        <span class="entry">{{no_result}}</span>
                    </span>
                </li>
            </ul>
        </section>
        <div :class="{'is-loading is-loading-dark': isLoadingMoreFixtures}" v-if="isLoadingMoreFixtures">
        </div>
    </div>
</template>

<script>
    import FixtureComponent from './FixtureComponent.vue'
    import MessageComponent from './MessageComponent.vue'

    export default {
        components: {FixtureComponent, MessageComponent},
        props: {
            no_result: String,
            results: {
                required: false,
            },
            team_id: {
                required: false,
                type: String,
                default: '',
            },
            all: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isLoading: true,
                fixtureDays: null,
                busy: false,
                scrolled: false,
                isLoadingMoreFixtures: false,
                showError: false,
                errorStatus: 'generic',
                errorMessage: '',
                stopRequesting: false,
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            if (typeof this.results !== 'undefined') {
                this.requestFixtures('/api/results');
            } else {
                this.requestFixtures('/api/fixtures');
            }
        },
        methods: {
            requestFixtures(endpoint) {
                this.isLoading = true;
                this.showError = false;
                if (this.team_id !== '') {
                    endpoint = endpoint + '?contestant_id=' + this.team_id
                }

                if (this.all) {
                    endpoint = endpoint + '&all=1'
                }
                axios.get(endpoint).then((response) => {
                    this.fixtureDays = response.data;
                    this.isLoading = false;
                }).catch(() => {
                    this.errorStatus = 'error';
                    this.errorMessage = 'Unable to get fixtures - Please try again later.';
                    this.showError = true;
                    this.isLoading = false;
                });
            },
            getResults() {
                if (typeof this.fixtureDays !== 'undefined') {
                    let lastFixture = this.getLastFixture();
                    this.requestNextFixtures('/api/fixtures/next-results', lastFixture);
                }
            },
            getFixtures() {
                if (typeof this.fixtureDays !== 'undefined') {
                    let lastFixture = this.getLastFixture();
                    this.requestNextFixtures('/api/fixtures/next-fixtures', lastFixture);
                }
            },
            requestNextFixtures(endpoint, lastFixture) {
                this.isLoadingMoreFixtures = true;
                endpoint = endpoint + '?contestant_id=' + this.team_id;

                axios.post(endpoint, {fixture: lastFixture}).then((response) => {
                    if (response.data.length === 0) {
                        this.stopRequesting = true;
                    }
                    this.fixtureDays = Object.assign({}, this.fixtureDays, response.data);
                    this.isLoadingMoreFixtures = false;
                }).catch(() => {
                    this.errorStatus = 'error';
                    this.errorMessage = 'Unable to get fixtures - Please try again later.';
                    this.showError = true;
                    this.isLoadingMoreFixtures = false;
                });
            },
            getLastFixture() {
                let dayKeys = Object.keys(this.fixtureDays);
                let lastDayKey = dayKeys[dayKeys.length - 1];
                let lastDay = this.fixtureDays[lastDayKey];
                return lastDay[lastDay.length - 1];
            },
            handleScroll(event) {
                if ((window.innerHeight + window.scrollY) > (document.body.scrollHeight - 10)) {
                    if (!this.stopRequesting) {
                        // you're at the bottom of the page
                        if (typeof this.results !== 'undefined') {
                            this.getResults();
                        } else {
                            this.getFixtures();
                        }
                    }
                }
            }
        }
    }
</script>
